// ================================
// MOBILE MENU - Hamburger menu for mobile devices
// ================================

(function() {
    'use strict';

    const hamburger = document.querySelector('.header__hamburger');
    const header = document.querySelector('.header');
    const mobileLinks = document.querySelectorAll('.header__link--mobile');
    
    if (!hamburger || !header) return;

    // Toggle menu
    function toggleMenu() {
        const isOpen = header.classList.contains('header--menu-open');
        
        if (isOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    // Open menu
    function openMenu() {
        header.classList.add('header--menu-open');
        hamburger.classList.add('header__hamburger--active');
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    // Close menu
    function closeMenu() {
        header.classList.remove('header--menu-open');
        hamburger.classList.remove('header__hamburger--active');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    // Event listeners
    hamburger.addEventListener('click', toggleMenu);

    // Close menu when clicking on a link (for one-page navigation)
    mobileLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // If it's an anchor (starts with #), close menu
            const href = this.getAttribute('href');
            if (href && href.startsWith('#')) {
                closeMenu();
            }
        });
    });

    // Close menu on ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && header.classList.contains('header--menu-open')) {
            closeMenu();
        }
    });

    // Close menu on window resize (if it changes to desktop)
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (window.innerWidth > 992 && header.classList.contains('header--menu-open')) {
                closeMenu();
            }
        }, 250);
    });

})();
